import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconTrashcan = ({ className, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M1 4H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 4V12.5C3 13.3284 3.67157 14 4.5 14H9.5C10.3284 14 11 13.3284 11 12.5V4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 4V2.5C5 1.67157 5.67157 1 6.5 1H7.5C8.32843 1 9 1.67157 9 2.5V4" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconTrashcan
